import { useLogin } from "../hooks/useLogin";
import type { PopupRequest } from "@azure/msal-browser";
import React from "react";

export const LoginButton: React.FC<{ loginRequest: PopupRequest }> = ({
  loginRequest,
}) => {
  const login = useLogin();
  return (
    <button className="btn btn-primary" onClick={() => login(loginRequest)}>
      Login
    </button>
  );
};
